import React from "react";
import { FaCheckCircle } from "react-icons/fa";

export const About = (props) => {
  return (
    <div id="about" className="problem-section">
      <div className="container">
        <div className="row align-items-center">
          <div
            className="col-xs-12 col-md-6 solution-image"
            data-aos="fade-right"
            data-aos-duration="1000"
            data-aos-easing="ease-in-out"
          >
            <img
              src="img/about.jpg"
              className="img-responsive rounded shadow custom-image"
              alt="problems"
            />
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="problem-text">
              <h2> Does This Sound Familiar?</h2>
              <p>{props.data ? props.data.paragraph : "loading..."}</p>
              <h3>Common Challenges</h3>
              <div className="list-style row">
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why.map((d, i) => {
                        const [title, ...rest] = d.split(" - ");
                        return (
                          <li key={`${d}-${i}`} className="check-item" style={{ display: "flex", alignItems: "flex-start" }}>
                            <FaCheckCircle
                              color="green"
                              size={24} // yahan size pixels me, 24 ya 30 adjust kar sakte ho
                              style={{ marginRight: "8px", flexShrink: 0, marginTop: "4px" }}
                            />
                            <span>
                              <strong>{title}</strong>
                              <span style={{ fontSize: "16px", lineHeight: "1.5", color: "#333", marginLeft: "4px" }}>
                                {rest.join(" - ")}
                              </span>
                            </span>

                          </li>
                        );
                      })
                      : "loading"}

                  </ul>
                </div>
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why2.map((d, i) => {
                        const [title, ...rest] = d.split(" - ");
                        return (
                          <li key={`${d}-${i}`} className="check-item" style={{ display: "flex", alignItems: "flex-start" }}>
                            <FaCheckCircle
                              color="green"
                              size={24} // yahan size pixels me, 24 ya 30 adjust kar sakte ho
                              style={{ marginRight: "8px", flexShrink: 0, marginTop: "4px" }}
                            />
                            <span>
                              <strong>{title}</strong> {rest.join(" - ")}
                            </span>
                          </li>
                        );
                      })
                      : "loading"}

                  </ul>
                </div>
              </div>
              <a href="#solution" className="btn btn-custom mt-4">
                See How We Solve This →
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
